import React, { useCallback, useEffect } from 'react'
import { onClientSide, sendDataLayer } from '@/utils/utils'

import { DATALAYER_MODELS } from '../../pages'
import { parseTrackingData } from '../helpers/parseTrackingData'
import { validateCustomTrackingData } from '../helpers/validate'

const noSSR = callback => (onClientSide() ? callback : () => {})

const defaultOptions = {
  customDispatch: () => {},
  dispatchOnMount: false,
}

const useTracking = (trackingData = null, options = defaultOptions) => {
  const { customDispatch, dispatchOnMount } = options

  const dispatchAnalyticsEvent = useCallback(
    data => {
      try {
        validateCustomTrackingData(data)

        const pageBasicTrackingData = DATALAYER_MODELS[data.page]

        const { eventType, datalayer } = parseTrackingData(
          pageBasicTrackingData,
          data
        )

        sendDataLayer(datalayer, eventType)

        customDispatch(data)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    [customDispatch]
  )

  useEffect(() => {
    if (dispatchOnMount && trackingData) {
      dispatchAnalyticsEvent(trackingData)
    }
  }, [dispatchOnMount, trackingData, dispatchAnalyticsEvent])

  return {
    trackingData,
    dispatchAnalyticsEvent: noSSR(dispatchAnalyticsEvent),
  }
}

const withTracking = WrapperComponent => {
  return class extends React.Component {
    constructor(...props) {
      super(props)
    }

    dispatchEvent = data => {
      try {
        validateCustomTrackingData(data)
        const pageBasicTrackingData = DATALAYER_MODELS[data.page]

        const { eventType, datalayer } = parseTrackingData(
          pageBasicTrackingData,
          data
        )

        sendDataLayer(datalayer, eventType)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    }

    render() {
      return (
        <WrapperComponent
          {...this.props}
          dispatchAnalyticsEvent={noSSR(this.dispatchEvent)}
        />
      )
    }
  }
}

export { useTracking, withTracking }
